// extracted by mini-css-extract-plugin
export default {"share-button":"u5YKri","shareButton":"u5YKri","open":"SNHWhB","share-icon":"QnKORU","shareIcon":"QnKORU"};